import React from "react";
import Twitter from "../assets/images/twitter-black.svg"

function Socials() {
  return (
    <>
    <div className="socials-links">
      <ul>
        <li>
          <a href="https://twitter.com/MocaverseNFT" className="socials" target="_blank" without rel="noreferrer"><img src={Twitter} alt="Twitter" /></a>
        </li>
      </ul>
    </div>
    </>
  );
}

export default Socials;
